export enum AlertType {
  SuccessCreate,
  SuccessUpdate,
  ErrorCreate,
  ErrorUpdate,
}
